import { Link } from 'react-router-dom';
import { MessageCircle, Phone, ArrowRight } from 'lucide-react';
import { useT } from '../i18n/LangContext';
import { PHONE_HREF } from '../data/content';

export function WhatsAppPill() {
  const t = useT();
  return (
    <a data-testid="whatsapp-pill" href="https://wa.me/16138595893?text=Hi%20Reverence%20Services%2C%20I%27d%20like%20a%20free%20quote"
      target="_blank" rel="noopener noreferrer" aria-label={t['ov.chat']}
      className="fixed bottom-24 right-4 z-40 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-sm font-bold text-white shadow-[0_10px_30px_rgba(37,211,102,0.4)] transition-transform duration-300 hover:-translate-y-1 md:bottom-6 md:right-6">
      <MessageCircle className="h-5 w-5" />
      <span className="hidden sm:inline">{t['ov.chat']}</span>
    </a>
  );
}

export function MobileBar() {
  const t = useT();
  return (
    <div data-testid="mobile-sticky-bar" className="fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 border-t border-white/10 bg-ink/95 backdrop-blur-xl md:hidden">
      <a data-testid="mobile-bar-call" href={PHONE_HREF} className="flex items-center justify-center gap-2 py-4 text-sm font-bold uppercase tracking-wider text-white">
        <Phone className="h-4 w-4 text-gold" /> {t['ov.call']}
      </a>
      <Link data-testid="mobile-bar-quote" to="/quote" className="flex items-center justify-center gap-2 bg-gold py-4 text-sm font-bold uppercase tracking-wider text-ink">
        {t['ov.freeQuote']} <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
